import React, { useMemo } from "react";
import Slider from "react-slick";
import { Skeleton } from "antd";
import useFetchApiData from "../helper/useFetchApiData";
import Link from "antd/es/typography/Link";

const BannerOne = () => {
  const banner = useFetchApiData("/banners");
  console.warn(banner);

  // Memoize settings to avoid recalculating on each render
  const settings = useMemo(
    () => ({
      arrows: true,
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <Arrow icon="ph-caret-right" />,
      prevArrow: <Arrow icon="ph-caret-left" />,
    }),
    [] // Dependency array is empty as settings don't depend on props or state
  );

  // Loading skeleton while banner data is not loaded
  if (!banner || banner.length === 0) {
    return (
      <div className="container container-lg p-10">
        <Skeleton active paragraph={{ rows: 4 }} />
      </div>
    );
  }

  return (
    <div className="banner px-0 py-0">
      <div className="container container-lg">
        <div className="banner-item rounded-24 overflow-hidden position-relative p-0">
          <a
            href="#featureSection"
            className="scroll-down w-84 h-84 flex-center bg-main-600 rounded-circle border border-5 text-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-800"
          >
            <i className="ph ph-caret-double-down" />
          </a>
          <img
            src="/assets/images/bg/banner-bg.png"
            alt=""
            className="banner-img position-absolute w-100 h-100 object-fit-cover"
          />
          <div className="banner-slider">
            <Slider {...settings}>
              {banner.map((item) => {
                // Conditionally set the href based on category_id or product_id
                let link = "#"; // Default link if no category_id or product_id
                if (item.category_id) {
                  link = `/category/${item.category_id}`;
                } else if (item.product_id) {
                  link = `/product-details/${item.product_id}`;
                }

                return (
                  <a href={link}>
                  <div key={item.id} className="banner-slider__item">
                  <div className="banner-item__thumb1 py-0">
                    <img
                      src={item.image_fullpath}
                      alt=""
                      className="main-banner-image rounded-24 py-0"
                    />
                  </div>
                </div>
                </a>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

// Memoize Arrow component to avoid unnecessary re-renders
const Arrow = React.memo(({ className, onClick, icon }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${className} slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
  >
    <i className={`ph ${icon}`} />
  </button>
));

export default BannerOne;
